import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../Common/Constants";
import { useSelector } from "react-redux";
import { getParamsSelector } from "../Common/Slices/ParamSlice";
import {defaultDate} from "../Common/Constants"
//import { identity, orderBy, update } from "lodash";
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent } from "@progress/kendo-react-grid";
import { addToInterruptData, getInterruptsSelector, loadingInterruptsSelector} from "./machineHealthSlice";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch } from "../Core/store.hooks";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { machineHealthDataToHours, machineTimesToHours, msToHours } from "../Common/Util_methods/format";
import { Series } from "./MachineHealthFilters";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { orderBy } from "@progress/kendo-data-query";

interface MachineHealthProps{
    id:string;
    header:string;
    addSeries:Function;
}

interface InterruptData{
  dailyData: any[];
  deviceCount: number;
  deviceData: any[];
  end: string;
  interruptCount: number;
  interruptsPerRunningHour: number;
  runningDuration: number;
  seriesID: string;
  start: string;
}

interface PageState {
  skip: number;
  take: number;
}

const MachineHealth = (props:MachineHealthProps) => {
    const initialSort: any = [{
        field: "interruptsPerRunningHour",
          dir: "desc",
      },];
    const initialDataState: PageState = { skip: 0, take: 100 };

    const [gridData, updateGridData] = useState<InterruptData>();
    const [fetchedSeries, updateFetchedSeries] = useState([])
    const [selectedSeries, updateSelectedSeries] = useState(null);
    const [seriesCount, updateSeriesCount] = useState(null);

    const [interruptDataInHours, updateInterruptDataInHours] = useState([])
    const [dataProcessed, setDataProcessed] = useState(false);

    const [page, setPage] = useState<PageState>(initialDataState);
    const [sort, setSort] = useState(initialSort);


    const interruptData = useSelector(getInterruptsSelector).interruptData;
    const loadingState = useSelector(loadingInterruptsSelector);

    
    useEffect(()=>{
      if(interruptData.length > 0 && loadingState !== "pending"){
        updateInterruptDataInHours(machineHealthDataToHours(interruptData))
      }else{
        updateInterruptDataInHours([]);
      }
    },[interruptData])

    useEffect(()=>{
      if(interruptDataInHours.length > 0){
        updateFetchedSeries(interruptDataInHours.map((obj)=>obj.seriesID))
          if (selectedSeries === null) {
              updateGridData(interruptDataInHours[0])
              updateSelectedSeries(interruptDataInHours[0].seriesID)
              updateSeriesCount(interruptDataInHours.length);
          } else if (interruptDataInHours.length === seriesCount) {
              const data = interruptDataInHours.find((obj) => obj.seriesID === selectedSeries)
              updateGridData(data)
          } else {
              updateGridData(interruptDataInHours[interruptDataInHours.length-1])
              updateSelectedSeries(interruptDataInHours[interruptDataInHours.length - 1].seriesID)
          updateSeriesCount(interruptDataInHours.length);
        }
        setPage(initialDataState)
        setDataProcessed(true)
     }
    },[interruptDataInHours])

    useEffect(()=>{
      if(loadingState === "pending"){
          setDataProcessed(false);
      }
      if(loadingState === "rejected"){
          setDataProcessed(true);
      }
      if(loadingState === "fulfilled" && interruptData.length === 0){
          setDataProcessed(true);
      }
  },[loadingState])

    useEffect(()=>{
      if(selectedSeries != null){
        const data = interruptDataInHours.find((obj)=>obj.seriesID === selectedSeries)
        updateGridData(data)
      }
    },[selectedSeries])

    const pageChange = (event: GridPageChangeEvent) => {
      setPage(event.page);
    };

    const seriesHandler = (e:DropDownListChangeEvent) =>{
      setPage(initialDataState)
      updateSelectedSeries(e.target.value)
    }

    const handleGridButton = (deviceWithSerial:string) =>{
        const newSeries:Series = {
          deviceName:null,
          deviceNameVersion:null,
          devicesWithSerial:[deviceWithSerial],
          deviceTypes:[]
        }
        props.addSeries(newSeries)
    }

    const CommandCell = (props:GridCellProps) => {
      return(
        <td> 
          <Button onClick={()=>handleGridButton(props.dataItem.deviceWithSerial)}>Add Series</Button>
        </td>
      )
    }

    if (!dataProcessed){
      return <Spinner text="data" />;
    }
    if (interruptDataInHours == null || loadingState === "rejected") {
      //proper error handling should be added with promise error response
      return (
          <ErrorMessage
              text={"Oops something went wrong, unable to get data."}
              id={props.id}
              header={props.header}
          />
      );
    }   
    if (interruptDataInHours != null && interruptDataInHours.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if(gridData != null){
      return (
        <Fragment>
          <div style={{display:"flex", flexDirection:"row"}}>
            <DropDownList 
              popupSettings={{width:"auto"}}
              data={fetchedSeries}
              value={selectedSeries}
              onChange={seriesHandler}
              style={{height:"fit-content"}}
            />
            <div style={{margin:"10px"}}>Total Interrupts: {gridData.interruptCount} </div>
            <div style={{margin:"10px"}}>Total Running Hours: {gridData.runningDuration} </div>
            <div style={{margin:"10px"}}>Total Interrupts / Running Hr: {gridData.interruptsPerRunningHour} </div>
            <div style={{margin:"10px"}}>Total Devices: {gridData.deviceCount} </div>
          </div>
          <Grid
            data={orderBy(gridData.deviceData,sort)}
            scrollable={"scrollable"}
            sortable
            sort={sort}
            onSortChange={(e) => {
                setSort(e.sort);
            }}
            style={{ maxHeight: "calc( 100% - 50px)", height: "calc( 100% - 50px)" }}
            >
            <GridColumn field="customerName" title="Customer" />
            <GridColumn field="cadid" title="CADID" />
            <GridColumn field="deviceWithSerial" title="Device" />
            <GridColumn field="interruptCount" title="Interrupt Count"/>
            <GridColumn field="runningDuration" title="Running Duration"/>
            <GridColumn field="interruptsPerRunningHour" title="Interrupts / Running Hr"/>
            <GridColumn cell={CommandCell} />
          </Grid>
        </Fragment>
      )
    }
    return null
}

export default MachineHealth;